// theme/index.js
import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"
import { Input } from "./InputTheme"

const config = defineConfig({
  theme: {
    components: {
      Input,
    },
  },
})

export const system = createSystem(defaultConfig, config)